"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconCloudService = function IconCloudService(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M23.96 20.95c6.128 0 11.096 4.975 11.096 11.11 0 6.136-4.968 11.11-11.096 11.11s-11.096-4.974-11.096-11.11 4.968-11.11 11.096-11.11m0 2c-5.025 0-9.1 4.08-9.1 9.11.001 5.032 4.076 9.11 9.1 9.11 5.025 0 9.099-4.078 9.099-9.11 0-5.03-4.074-9.11-9.099-9.11m4.005 10.21h1.788L26.966 38l-2.786-4.84h1.788V28h1.997zM26.966 5c6.694 0 11.95 5.474 12.234 12.296l.007.281.076.008c4.68.499 8.383 4.338 8.646 9.166l.01.274c-.13 5.177-4.301 9.316-9.44 9.433l-.266.002h-1.319v-2h1.319v.8l.005-.8c4.175.02 7.6-3.306 7.706-7.433a7.706 7.706 0 0 0-7.483-7.494l-.245-.003-1.002.004v-1.617C37.233 11.88 32.723 7 26.986 7a11.52 11.52 0 0 0-9.739 5.733l-.16.286-.686 1.26-.944-1.082A6.42 6.42 0 0 0 10.987 11c-2.618 0-4.445 2.094-4.445 5.003q0 .495.054.988l.044.327.096.624-.523.356A9.62 9.62 0 0 0 1.997 26c0 4.642 3.896 8.327 8.725 8.457l.265.003v2C4.967 36.46 0 31.868 0 25.975a11.64 11.64 0 0 1 4.542-8.935l.05-.037-.018-.19q-.015-.204-.023-.407L4.544 16c0-3.954 2.657-7 6.493-6.999a8.44 8.44 0 0 1 4.807 1.814l.164.135.027-.039a13.53 13.53 0 0 1 10.592-5.9zM23.76 30.84h-1.787V36h-1.998v-5.16h-1.787L20.974 26z"
  })));
};

export { IconCloudService, IconCloudService as default };
